import { createSlice } from "@reduxjs/toolkit"

// Define initial state for the slice.

const initialState = {
  data: [],
  loading: false,
  error: null,
  receipt: {},
  uploadFile: { loading: false, error: null },
  items: { loading: false, error: null, data: [] },
  drafts: { loading: false, error: null, data: [] },
  ProvidedStatus: { loading: false, error: null, data: null },
  receiptsList: { loading: false, error: null, data: [] },
  receiptFields: { loading: false, error: null, data: null },
}
//  Define slice and it's reducer functions.
const providerInSlice = createSlice({
  name: "providerIn",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
    setProviderIn(state, action) {
      state.receipt = action.payload
    },
    setUploadFile(state, action) {
      state.uploadFile = {
        loading: action.payload.loading,
        error: action.payload.error,
      }
    },
    setItems(state, action) {
      state.items = {
        data: action.payload.data,
        loading: action.payload.loading,
        error: action.payload.error,
      }
    },

    setDraftsLoading(state, action) {
      state.drafts.loading = action.payload
    },
    setDrafts(state, action) {
      state.drafts.data = action.payload
      state.drafts.error = null
    },

    setDraftsError(state, action) {
      state.drafts.error = action.payload
    },
    setProvidedStatus(state, action) {
      state.ProvidedStatus = {
        data: action.payload.data,
        loading: action.payload.loading,
        error: action.payload.error,
      }
    },
    setReceiptsList(state, action) {
      state.receiptsList = {
        data: action.payload,
        loading: false,
        error: null,
      }
    },
    setReceiptFields(state, action) {
      state.receiptFields = {
        data: action.payload,
        loading: false,
        error: null,
      }
    },
    resetState(state) {
      state.data = []
      state.loading = false
      state.error = null
      state.receipt = {}
      state.uploadFile = { loading: false, error: null }
      state.drafts = { loading: false, error: null, data: [] } // Reset drafts too
    },
    resetItems(state) {
      state.items = { loading: false, error: null, data: [] }
    },
    resetProvidedStatus(state) {
      state.ProvidedStatsu = { loading: false, error: null, data: null }
    },
  },
})

export const providerInAction = providerInSlice.actions

export default providerInSlice
